module.exports = __webpack_public_path__ + "img/myzjlogo.7b36c41d.png";